const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.26583 101.44937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m85.07705,60.24862c-8.15134,0-14.75725,6.60478-14.75725,14.75601,0,8.15308,6.60591,14.76032,14.75725,14.76032s14.76186-6.60724,14.76186-14.76032c0-8.15123-6.61012-14.75601-14.76186-14.75601Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.53097,
    y1: 68.45835,
    x2: 91.62773,
    y2: 81.55523,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.53097,
    y1: 81.55523,
    x2: 91.62773,
    y2: 68.45835,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.1851,59.755c.65572-.75913,1.32659-1.53518,2.01301-2.32852l3.04807-.007c5.48239-.38424,18.27197-.65127,18.27441-7.72385-.00244-6.87589-14.9855-7.27962-21.31913-7.72354C55.45911,7.59476,57.95274,5.68573,54.08138,5.67903l-3.86345.00365,17.62923,37.16629-24.45641,1.79304-9.55525-10.55361h-7.40232l9.797,14.79277-9.78269,16.23749,7.39167.00335,9.55342-10.5533,24.45641,1.79608-17.62741,37.3511h3.85796c2.88304,0,3.88934-1.02204,16.53294-15.78002",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelacion);
export default __webpack_public_path__ + "static/media/cancelacion.b4a0c1d6aaa21732cb63089ca94c149b.svg";
export { ForwardRef as ReactComponent };